module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"general_stats":"General stats","num_loans":"Number of loans","num_subjects":"Number of subjects","interest_distribution":"Interest distribution","interest_distribution_info":"Distribution of subjects based on number of loans"},"cs":{"general_stats":"Celkové statistiky"}}')
  delete Component.options._Ctor
}
